
import type { PropType } from 'vue'
import type { ExplainMessages, RegularFilter } from '../../../models'

import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { PermissionLevelEnum } from '@empathybroker/tsclient-play/dist/enums/permission-level.enum'
import { computed, defineComponent, getCurrentInstance } from 'vue'

import { mapGetters, useFeature } from '../../../composables'

import { useExplainBrowse } from '../../../composables/explain/use-explain-browse'
import { FeatureIdEnum } from '../../../enums'
import { CONTEXT_CONSTS } from '../../../store/context/context.consts'
import { EpbButton } from '../../shared/epb-button'
import ExplainFilters from '../explain-filters.component.vue'
import ExplainHeaderDownloadButton from '../explain-header-download-button.component.vue'
import ExplainQueryMetrics from '../explain-query-metrics.component.vue'
import ExplainSearchModeToggle from '../explain-search-mode-toggle.component.vue'
import ExplainHeaderLayout from '../header-layout.component.vue'
import ExplainSearchSearchBox from './search-box.component.vue'

export enum SearchMode {
  KEYWORD = 'search',
  HYBRID = 'hybrid',
  SEMANTICS = 'semantics',
}

export default defineComponent({
  name: 'ExplainSearchHeader',
  components: {
    EpbButton,
    ExplainFilters,
    ExplainSearchSearchBox,
    ExplainSearchModeToggle,
    ExplainHeaderDownloadButton,
    ExplainHeaderLayout,
    ExplainQueryMetrics,
  },
  props: {
    messages: {
      type: Object as PropType<ExplainMessages>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object as PropType<Record<string, RegularFilter>>,
      required: true,
    },
    isSearchBoxDisabled: {
      type: Boolean,
      required: true,
    },
    showFilters: {
      type: Boolean,
      required: true,
    },
    showFiltersButton: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const ctx = getCurrentInstance()
    if (!ctx) {
      throw new Error("'ctx' is not defined")
    }

    const { getFeatureNode } = useFeature()
    const { isBrowseContext } = useExplainBrowse()

    const { context } = mapGetters(ctx.proxy.$store, CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context,
    })

    const query = computed(() => {
      return context.value.query
    })

    const isSearchModeToggleVisible = computed(() => {
      const innovationsPermissionLevel = getFeatureNode(
        FeatureIdEnum.INNOVATIONS,
        DomainEnum.GLOBAL,
      )?.permissionLevel

      return (
        innovationsPermissionLevel !== PermissionLevelEnum.NONE &&
        innovationsPermissionLevel !== undefined &&
        query.value
      )
    })

    return {
      query,
      isSearchModeToggleVisible,
      isBrowseContext,
    }
  },
  data() {
    return {
      baseClass: 'epb-explain-search-header',
    }
  },
})
